<template>
  <div>
    <Header
      :show_language_selector="show_language_selector"
      :locale="locale"
      homelink
    />
    <div class="mt-5 container">
      <Index :is_guest="true" />
    </div>
  </div>
</template>
<script>
import Index from "./index.vue";
import Header from "../newhomepage/header.vue";
export default {
  components: { Index, Header },
  data() {
    return {
      show_language_selector: false,
    };
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "cn";
          break;
        case "en":
          locale = "en";
          break;
      }
      return locale;
    },
  },
};
</script>
